"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderImg = exports.ProviderImgWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const constants_1 = require("../../lib/constants");
exports.ProviderImgWrapper = styled_1.default.div `
  height: ${({ isCircle }) => (isCircle ? constants_1.PROFILE_IMAGE_WIDTH : 'fit-content')};
  width: ${constants_1.PROFILE_IMAGE_WIDTH};
  overflow: hidden;
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_image_placeholder')};
  background: ${(0, ui_theme_1.fromTheme)('color_image_placeholder')};
  border-radius: ${(props) => {
    const customerConfigValue = (0, ui_theme_1.fromTheme)('provider_profile_provider_image_border_radius')(props);
    return customerConfigValue ? customerConfigValue : 'initial';
}};

  @media screen and (max-width: ${constants_1.BREAKPOINTS.small}px) {
    align-self: center;
    margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0 0;
  }

  // position next to name/specialties/badges on screens between small and medium width
  @media screen and (min-width: ${constants_1.BREAKPOINTS.small}px) {
    flex: 0 0 ${constants_1.PROFILE_IMAGE_WIDTH};
  }
`;
exports.ProviderImg = styled_1.default.img `
  display: block;
  width: 100%;
  max-width: ${constants_1.PROFILE_IMAGE_WIDTH};
  height: ${({ isCircle, isLandscape }) => isCircle && isLandscape ? constants_1.PROFILE_IMAGE_WIDTH : 'auto'};
  object-fit: ${({ isLandscape }) => (isLandscape ? 'cover' : 'initial')};
`;
//# sourceMappingURL=profile-image.styles.js.map